import { Navigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { useCopilotHome } from "@/hooks/useCopilotHome";
import { landingPath } from "@/lib/copilot-home";

interface PermissionGuardProps {
  permissionKey: string;
  children: React.ReactNode;
}

export function PermissionGuard({ permissionKey, children }: PermissionGuardProps) {
  const { can, firstAllowedPath } = usePermissions();

  if (!can(permissionKey)) {
    return <Navigate to={firstAllowedPath} replace />;
  }

  return <>{children}</>;
}

export function RedirectToFirstAllowed() {
  const { firstAllowedPath } = usePermissions();
  const copilotHome = useCopilotHome();
  if (copilotHome.loading) return null;
  return <Navigate to={landingPath(copilotHome.enabled, firstAllowedPath)} replace />;
}
